import type { PhysicalClientDataDto } from '../dto';
import type { PhysicalClientData } from '../models';

export const mapPhysicalClientDataDtoToModel = (
  dto: PhysicalClientDataDto,
): PhysicalClientData => ({
  ...dto,
});
